const addBookingInt = (
    location,
    agentlogin,
    payment,
    payableAmout,
    priceDetails,
    selectedFlight,
    dispatch,
    FlightAddBookingDispatch,
    PGCharge
  ) => {
    
    let formaddBooking = {
      orderId: location.state.orderID,
      supplier: location.state.intFlight.Supplier,
      userEmail: location.state.formData.email,
      userPhone: location.state.formData.phone,
      user_type: agentlogin && agentlogin.status === 200 ? "agent" : "guest",
      origin: location.state.returnBody.Segments[0].Origin,
      destination: location.state.returnBody.Segments[0].Destination,
      travelDate: location.state.returnBody.Segments[0].PreferredDepartureTime,
      returnDate: location.state.returnBody.Segments[1].PreferredDepartureTime,
      journeyType: location.state.returnBody.JourneyType === 2 ? "RoundTrip" : "",
      origin1: location.state.returnBody.Segments[1].Origin,
      destination1: location.state.returnBody.Segments[1].Destination,
      travelDate1: "",
      origin2: "",
      destination2: "",
      travelDate2: "",
      origin3: "",
      destination3: "",
      travelDate3: "",
      PGCharge: payment === "pay" ? 200 : 0,
      class: "Economy",
      nop: `${location.state.returnBody.AdultCount} | ${location.state.returnBody.ChildCount} | ${location.state.returnBody.InfantCount} `,
      airlineType: "",
      carrier: location.state.intFlight.AirlineCode,
      fareType: "R",
      eTicketType: "eTicket",
      //   actualFare:
      //     location.state.selectedReturn[0].Supplier === "TBO"
      //       ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
      //         Number(Math.round(location.state.OneflightData.Fare.markup)) -
      //         Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
      //         Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
      //       : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
      //         Number(Math.round(location.state.OneflightData.Fares.markup)) -
      //         Number(Math.round(location.state.OneflightData.Fares.partnerMarkup)) -
      //         Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
      markup: 0,
        partnerMarkup:0,
        agentMarkup:0,
      //   baseFare:
      //     location.state.OneflightData.Supplier === "TBO"
      //       ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
      //         Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
      //         Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
      //       : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
      //         Number(Math.round(location.state.OneflightData.Fares.partnerMarkup)) -
      //         Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
      //   totalFare:
      //     location.state.OneflightData.Supplier === "TBO"
      //       ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
      //         Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
      //       : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
      //         Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
      payableAmount: 0,
      ticketCost: 0,
      totalEarn: 0,
      cashBack: "0.00",
      couponDiscount: 0.0,
      couponDetails: "",
      pricingDetails: priceDetails,
      selectedFlight: '',
      airlineType: "",
      selectedPax: location.state.BookingData,
      ticketSent: 0,
      paymentMode: agentlogin
        ? payment === "offline"
          ? "OFFLINE"
          : "ONLINE"
        : "ONLINE",
      agent_id:
        agentlogin && agentlogin.status === 200
          ? agentlogin && agentlogin.result.result.id
          : 0,
    };
    dispatch(FlightAddBookingDispatch(formaddBooking, payment));
    console.log("add booking", formaddBooking);
  };
  export default addBookingInt;
  